const buynowButton = document.querySelector(
  ".shopify-payment-button__button.shopify-payment-button__button--unbranded",
);

if (buynowButton) buynowButton.innerText = "Buy Now";

function initQuantityPrice() {
  const qtyInput = document.querySelector(".js-form .quantity__input");
  if (!qtyInput) return;

  function updatePrices() {
    let qty = Number(qtyInput.value);
    if (!qty || qty < 1) qty = 1;

    const priceEls = document.querySelectorAll(".js-form .js-total-price");

    priceEls.forEach((priceEl) => {
      const basePrice = Number(priceEl.dataset.price);
      const total = basePrice * qty;

      if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
        priceEl.textContent = Shopify.formatMoney(total);
      } else {
        priceEl.textContent =
          "Rs " +
          (total / 100).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
          });
      }
    });
  }

  qtyInput.addEventListener("input", updatePrices);
  qtyInput.addEventListener("change", updatePrices);

  // Initial calculation
  updatePrices();
}

// Initialize on page load
initQuantityPrice();

// Recalculate if user comes back via browser back button
window.addEventListener("pageshow", () => {
  initQuantityPrice();
});

const addToCartForm = document.querySelector(".js-form .form");

if (addToCartForm) {
  addToCartForm.addEventListener("submit", () => {
    const qtyInput = document.querySelector(".js-form .quantity__input");

    if (qtyInput) {
      qtyInput.value = 1;

      // Trigger existing price recalculation logic
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });
}
